import styled from '@emotion/styled';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Spin } from 'antd';
import { device } from 'utils';
import { Link, Redirect } from 'react-router-dom';
import { SingUpForm, ForgetPassword } from 'components';
import { authActions } from 'redux/actions';
import PropTypes from 'prop-types';
import { GoogleLogin } from '@react-oauth/google';

const FormItem = Form.Item;

const LoginFormWrapper = styled.div`
  max-width: 400px;
  background: #ffffff;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media ${device.allMobile} {
    width: 100%;
    min-width: 1px;
    max-width: 100%;
    min-height: auto;
    box-shadow: none;
    border-radius: 0;
  }
`;

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;



const TitleGroup = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
`;

const Subtitle = styled.p`
  margin: 4px 0 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #535862;
`;

const Body = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label {
    padding-bottom: 6px;

    > label {
      font-family: 'Inter', sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #414651;
      height: auto;
    }
  }

  .ant-input,
  .ant-input-affix-wrapper {
    height: 44px;
    padding: 10px 14px;
    border: 1px solid #d5d7da;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #181d27;
  }

  .ant-input::placeholder,
  input::placeholder {
    color: #717680;
  }

  .ant-input-affix-wrapper input {
    height: auto;
    padding: 0;
    box-shadow: none !important;
  }

  .ant-input-affix-wrapper-focused,
  .ant-input:focus,
  .ant-input-focused {
    border-color: #9dbc60;
    box-shadow: 0 0 0 2px rgba(157, 188, 96, 0.12);
  }

  input[type='email'],
  input[type='password'] {
    @media ${device.allMobile} {
      font-size: 16px !important;
      border: none;
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: transparent;
    }
  }
`;

const LinksRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: -4px;
  margin-bottom: 8px;

  a {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3f621a;
    text-decoration: none;
  }

  @media ${device.allMobile} {
    a {
      font-size: 13px;
    }
  }
`;

const Actions = styled.div`
  padding: 32px 0px 0px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LoginButton = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #9dbc60;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
`;

const GoogleButtonWrap = styled.div`
  width: 100%;
  height: 44px;

  > div {
    width: 100% !important;
  }

  iframe {
    width: 100% !important;
  }
`;

const FooterSpacer = styled.div`
  height: 20px;
`;

class LoginForm extends Component {
  static propTypes = {
    user: PropTypes.object,
    loading: PropTypes.bool,
    errors: PropTypes.array,
    login: PropTypes.func.isRequired,
  };

  state = {
    currentForm: 'login',
    redirectToProfile: false,
  };

  onFinish = (values) => {
    const { login } = this.props;
    login(values);

    if (this.props.onLoginSuccess) {
      this.props.onLoginSuccess();
    } else {
      this.setState({ redirectToProfile: true });
    }
  };

  handleCurrentFormState = (currentForm) => {
    this.setState({ currentForm });
  };

  handleSuccess = (response) => {
    const token = response.credential;
    this.props.loginWithGoogle({ token });

    if (this.props.onLoginSuccess) {
      this.props.onLoginSuccess();
    } else {
      this.setState({ redirectToProfile: true });
    }
  };

  handleError = () => {
    console.log('Google login failed');
  };

  render() {
    const { currentForm, redirectToProfile } = this.state;
    const {
      loading,
      user,
      navigate,
      handelCloseModal,
      setDoPayment,
      donationType,
      handleGetRecurringPayment,
    } = this.props;

    const userToken = localStorage.getItem('access-token');
    const client = localStorage.getItem('client');
    const isLoggedIn = !user?.user && userToken && client;

    if (isLoggedIn && navigate === false) {
      handelCloseModal();
      if (setDoPayment) setDoPayment(true);
    }

    if (isLoggedIn && handleGetRecurringPayment) {
      handleGetRecurringPayment();
    }

    if (redirectToProfile && isLoggedIn) {
      if (navigate === false) {
        handelCloseModal();
        if (setDoPayment) setDoPayment(true);
      } else {
        return <Redirect to="/profile" />;
      }
    }

    return (
      <LoginFormWrapper>
        {currentForm === 'login' && (
          <Spin spinning={loading}>
            <Header>
              <TitleGroup>
                <Title>Anmelden</Title>
                <Subtitle>Bitte melde dich an, um fortzufahren.</Subtitle>
              </TitleGroup>
            </Header>

            <Body>
              <StyledForm
                name="login"
                layout="vertical"
                onFinish={this.onFinish}
              >
                <FormItem
                  name="email"
                  label="E-Mail"
                  rules={[
                    {
                      required: true,
                      message: 'Bitte gib deine E-Mail Adresse ein.',
                    },
                  ]}
                >
                  <Input placeholder="Deine E-Mail-Adresse" type="email" />
                </FormItem>

                <FormItem
                  label="Passwort"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Bitte gib dein Passwort ein.',
                    },
                  ]}
                >
                  <Input placeholder="Passwort" type="password" />
                </FormItem>

                <LinksRow>
                  <Link
                    to="#!"
                    onClick={() => {
                      this.handleCurrentFormState('register');
                    }}
                  >
                    Neu hier? Jetzt registrieren!
                  </Link>

                  <Link
                    to="#!"
                    onClick={() =>
                      this.setState({ currentForm: 'forget-password' })
                    }
                  >
                    Passwort vergessen?
                  </Link>
                </LinksRow>

                <Actions>
                  <LoginButton type="submit">Anmelden</LoginButton>

                  <GoogleButtonWrap>
                    <GoogleLogin
                      onSuccess={this.handleSuccess}
                      onError={this.handleError}
                      theme="outline"
                      text="signin_with"
                      shape="rectangular"
                      size="large"
                      width="auto"
                      height={44}
                    />
                  </GoogleButtonWrap>
                </Actions>
              </StyledForm>
            </Body>

            <FooterSpacer />
          </Spin>
        )}

        {currentForm === 'register' && (
          <SingUpForm
            handleCurrentFormState={this.handleCurrentFormState}
            handelCloseModal={handelCloseModal}
            navigate={navigate}
            onRegisterSuccess={this.props.onRegisterSuccess}
          />
        )}

        {currentForm === 'forget-password' && (
          <ForgetPassword
            handleCurrentFormState={this.handleCurrentFormState}
          />
        )}
      </LoginFormWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors, isLoggedIn } = state.authentication;
  const { donationType } = state.payment;

  return {
    user,
    loading,
    errors,
    donationType,
    isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: (user) => dispatch(authActions.login(user)),
  loginWithGoogle: (user) => dispatch(authActions.loginWithGoogle(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
